var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolstice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.237 5.828c-.766 0-1.38.611-1.38 1.371S5.47 8.57 6.236 8.57c2.062 0 4.041 1.123 4.723 3.006a6.856 6.856 0 00-.599-2.543C9.563 7.33 7.684 5.828 6.237 5.828z",
    fill: "url(#Solstice_svg__paint0_linear_7243_135992)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.63 8.931c.548 1.19.748 2.478.565 3.733a5.682 5.682 0 01-.749 2.395c-.881 1.537-2.578 2.197-4.208 2.197h.017a2.755 2.755 0 00-2.761 2.742h2.744c3.942 0 7.135-3.171 7.135-7.086 0-3.502-2.544-6.409-5.721-6.97 1.28.561 2.328 1.602 2.977 2.99z",
    fill: "url(#Solstice_svg__paint1_linear_7243_135992)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M6.237 5.828c-.766 0-1.38.611-1.38 1.371S5.47 8.57 6.236 8.57c2.062 0 4.041 1.123 4.723 3.006a6.856 6.856 0 00-.599-2.543C9.563 7.33 7.684 5.828 6.237 5.828z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.119 14.155c.765 0 1.38-.612 1.38-1.371 0-.76-.615-1.372-1.38-1.372-2.063 0-4.042-1.123-4.724-3.006.033.86.233 1.735.599 2.544.798 1.701 2.694 3.205 4.125 3.205z",
    fill: "url(#Solstice_svg__paint2_linear_7243_135992)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.744 11.067c-.549-1.19-.748-2.478-.565-3.733a5.683 5.683 0 01.748-2.395c.882-1.536 2.578-2.197 4.208-2.197H7.12A2.755 2.755 0 009.879 0H7.136C3.193 0 0 3.171 0 7.086c0 3.502 2.545 6.41 5.722 6.97-1.298-.577-2.346-1.618-2.978-2.989z",
    fill: "url(#Solstice_svg__paint3_linear_7243_135992)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M7.119 14.155c.765 0 1.38-.612 1.38-1.371 0-.76-.615-1.372-1.38-1.372-2.063 0-4.042-1.123-4.724-3.006.033.86.233 1.735.599 2.544.798 1.701 2.694 3.205 4.125 3.205z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Solstice_svg__paint0_linear_7243_135992",
    x1: 2.847,
    y1: 21.797,
    x2: 12.286,
    y2: -1.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#489D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70BF44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Solstice_svg__paint1_linear_7243_135992",
    x1: 5.385,
    y1: 22.805,
    x2: 14.824,
    y2: -0.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#489D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70BF44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Solstice_svg__paint2_linear_7243_135992",
    x1: 1.235,
    y1: 21.156,
    x2: 10.674,
    y2: -2.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#489D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70BF44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Solstice_svg__paint3_linear_7243_135992",
    x1: -1.302,
    y1: 20.147,
    x2: 8.137,
    y2: -3.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70BF44"
  })))));
}
export default SvgSolstice;